<script setup>
import { PopoverButton } from "@headlessui/vue";
import { Link } from "@inertiajs/vue3";
</script>

<template>
    <PopoverButton
        :as="Link"
        class="block w-full px-2 text-left no-underline"
    >
        <slot />
    </PopoverButton>
</template>
